import { template as template_cdb8da42046e402b94eedcfd977dbdb1 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_cdb8da42046e402b94eedcfd977dbdb1(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
